<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Stream History</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>From Date</u></label>
        <input type="date" [(ngModel)]="filterable.fromDate" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>To Date</u></label>
        <input type="date" [(ngModel)]="filterable.toDate" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for="">Filter by Advertiser</label>
        <select [(ngModel)]="filterable.advertiser" class="form-control" placeholder="Advertiser" (ngModelChange)="changeAdvertiser($event)">
          <option *ngFor="let advertiser of advertiserList" [ngValue]="advertiser">{{advertiser.advertiser}} - {{advertiser.offerId}}</option>
        </select>
      </div>
      <div class="col" *ngIf="affiliateList != null && affiliateList.length > 0">
        <label for="">Filter by Affiliate</label>
        <select [(ngModel)]="filterable.affiliate" class="form-control" placeholder="Affiliate">
          <option value=null selected>All</option>
          <option *ngFor="let affiliate of affiliateList" [ngValue]="affiliate">{{affiliate.affiliate}}</option>
        </select>
      </div>
      <div class="col">
        <label for="">Filter by QueryString</label>
        <input type="text" [(ngModel)]="filterable.queryString" class="form-control" placeholder="Query String"/>
      </div>
      <div class="col">
        <label for=""><u>Postback State</u></label>
        <select [(ngModel)]="filterable.panOutState" class="form-control" placeholder="">
          <option value="" selected>-select state-</option>
          <option *ngFor="let pan of panOutStateList | keyvalue" [value]="pan.key">{{pan.value}}</option>
        </select>
      </div>
      <div class="col text-right align-self-end">
          <button class="btn btn-danger btn-sm mr-2" (click)="onClear()">Clear</button>
          <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
</div>
<table id="moList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead>
    <tr>
      <th>Received Time</th>
      <th>Advertiser</th>
      <th>OfferID</th>
      <th>Affiliate</th>
      <th>Affiliate Origin</th>
      <th>ReceiveRequestString</th>
      <th>Postback<br>(State,Time,URL,Result)</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="12">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="12">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let stream of streamList; index as i;">
      <td nowrap class="">{{stream.createdAt | date: 'long'}}</td>
      <td nowrap>{{stream.advertiser}}</td>
      <td>{{stream.offerId}}</td>
      <td>{{stream.affiliate}}</td>
      <td>{{stream.originAffiliate}}</td>
      <td class="text-left">{{stream.uriVariables}}</td>
      <td class="text-left">
        <span class="font-italic font-weight-bold">State:</span>{{stream.panOutStateView}}<br>
        <span class="font-italic font-weight-bold">DryState:</span>{{stream.dryPanOutStateView}}<br>
        <span class="font-italic font-weight-bold">At:</span>{{stream.panOutAt | date: 'long'}}<br>
        <span class="font-italic font-weight-bold">URL:</span>{{stream.panOutUrl}}<br>
        <span class="font-italic font-weight-bold">Result:</span>{{stream.panOutMsg}}
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="12" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
      </td>
    </tr>
  </tfoot>
</table>
